import React from 'react';
import { Badge, Button, Divider, Menu, MenuButtonProps, MenuItem, MenuList, MenuPopover, MenuTrigger, Spinner, SplitButton } from '@fluentui/react-components';
import { Add24Filled, ArrowSync20Regular, Payment24Regular, ClipboardCheckmark24Regular, ClipboardArrowRight24Regular, ClipboardClock24Regular, EyeOff20Regular } from '@fluentui/react-icons';
import { PractitionerConsumption } from '../../../../../models/Entities/Practitioners/PractitionerConsumption';
import './PractitionerConsumption.Menu.Styles.css';
import { ExportToExcelLink } from '../../../../ExportToExcel/ExportToExcelLink.Component';
import { IConsumptionsFilters } from '../../../../../models/Filters/ConsumptionsFilters';

/*
    status
    -----------------------------
    NotSettled = 0,
    Pending = 1,
    Payee = 2,
    Settled = 3,
    Rejected = 4,
    Ignored = 5,
    ToSettle = 6
 */

interface Props {
    Filters: IConsumptionsFilters;
    PractitionerId: string;
    SelectedConsumptions: PractitionerConsumption[];
    isChangingStatus: boolean;
    isAddingConsumption: boolean;
    onRequestUpdate: () => void;
    onAddConsumption: () => void;
    ChangeStatus: (practitionerId: string, consumptionId: string, status: number, isForAll: boolean) => void;
}

const PractitionerConsumptionMenuComponent = (props: Props) => {

    const onReloadConsumptions = () => {
        props.onRequestUpdate();
    };

    const changeStatusTo = (status: number) => {
        props.SelectedConsumptions.forEach(element => {
            props.ChangeStatus(props.PractitionerId, element.id, status, false);
        });
    };

    const onClickMarkAsPaid = () => changeStatusTo(2);
    const onClickMarkToSettled = () => changeStatusTo(6);
    const onClickMarkAsRejected = () => changeStatusTo(4);
    const onClickMarkAsPending = () => changeStatusTo(0);
    const onClickMarkAsIgnored = () => changeStatusTo(5);

    // Same shape as the protocol consumption list: the primary action marks the
    // selection as "A liquidar" and the remaining statuses live in the menu.
    const ChangeStatusToolbar = () => (
        <Menu positioning="below-end">
            <MenuTrigger disableButtonEnhancement>
                {(triggerProps: MenuButtonProps) => (
                    <SplitButton
                        menuButton={triggerProps}
                        primaryActionButton={{ onClick: onClickMarkToSettled }}
                        disabled={props.SelectedConsumptions?.length === 0}
                        appearance='secondary'
                        icon={props.isChangingStatus ? <Spinner size="extra-tiny" /> : <ClipboardCheckmark24Regular />}
                    >
                        A liquidar&nbsp;{props.SelectedConsumptions?.length > 0 && <Badge size='small' appearance="filled">{props.SelectedConsumptions?.length}</Badge>}
                    </SplitButton>
                )}
            </MenuTrigger>

            <MenuPopover>
                <MenuList>
                    <MenuItem onClick={onClickMarkAsPaid} icon={<Payment24Regular />}>Cobrado</MenuItem>
                    <MenuItem onClick={onClickMarkAsRejected} icon={<ClipboardArrowRight24Regular />}>Rechazado</MenuItem>
                    <MenuItem onClick={onClickMarkAsPending} icon={<ClipboardClock24Regular />}>Pendiente</MenuItem>
                    <MenuItem onClick={onClickMarkAsIgnored} icon={<EyeOff20Regular />}>Ignorado</MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );

    return (
        <div className='menuContainer'>
            <Button appearance='primary' icon={props.isAddingConsumption ? <Spinner size="extra-tiny" /> : <Add24Filled />} onClick={props.onAddConsumption}>Agregar Consumo</Button>
            <Button appearance='secondary' onClick={onReloadConsumptions}><ArrowSync20Regular /></Button>
            <Divider vertical={true} />
            <ChangeStatusToolbar />
            <Divider vertical={true} />
            <ExportToExcelLink Filters={props.Filters} entityId={props.PractitionerId} Type='Practitioner' />
        </div>
    );
};

export default PractitionerConsumptionMenuComponent;
